
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M14.9 5.2L19.775 11.7C19.9083 11.8778 19.9083 12.1222 19.775 12.3L14.9 18.8C14.6117 19.1844 14 18.9805 14 18.5V14C14 14 12 14 9.49997 15C6.38578 16.2457 4.5 18 4.5 18C4.5 18 5.5 14 8.5 12C11.5 10 14 10 14 10V5.5C14 5.01949 14.6117 4.81559 14.9 5.2Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowshareFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
